module.exports = __webpack_public_path__ + "media/images/rank_ss-d34b37db40ded93317fdd4a255a03d32.gif";